module.exports = __webpack_public_path__ + "img/C2_HQ04.2d72f057.jpg";